export const setCookie = (key: string, value: string, days: number = 1) => {
  const seconds = days * 86400;
  let date = new Date(Date.now() + seconds * 1000);
  document.cookie = `${key}=${value}; expires=${date.toUTCString()}; path=/; max-age=${seconds}`;
};

export const getCookie = (key: string) => {
  var value = document.cookie.match('(^|;) ?' + key + '=([^;]*)(;|$)');
  return value ? value[2] : null;
};
